import {extractFormErrorsFromResponse, putAll, showSuccess, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {formHelpers} from 'utils/forms';
import {showBeError} from 'utils/show-be-error';

import {managementOtherSubjectFormName} from '../../types/management-other-subject-form-values';
import {adminAction, UpdateManagementOtherSubjectDetailAction} from '../action';

const te = t('common');
const title = te('updateEntry');

function* execute({payload: {otherSubjectId}}: UpdateManagementOtherSubjectDetailAction): SagaIterator {
    const formValues = yield* select(formHelpers.formValues(managementOtherSubjectFormName));
    yield* put(formHelpers.startSubmit(managementOtherSubjectFormName));

    const response = yield* call(Api.updateUserProfileOtherSubjectRoleBySubjectManager, {
        approvedTo: formValues.prop('approvedTo').orNull(),
        userProfileOtherSubjectRoleId: formValues
            .prop('userProfileRoleIds').headIn().orCrash('No userProfileRoleIds found'),
    });

    if (response.isSuccess) {
        yield* put(adminAction.getManagementOtherSubjectsTableData(
            opt({action: 'refresh'}),
            opt(otherSubjectId),
        ));
        yield* put(showSuccess(title, te('updateEntrySuccess'), false, 'updateManagementOtherSubject'));
        yield* put(adminAction.setManagementSubjectModalVisible(null));
        yield* put(formHelpers.reset(managementOtherSubjectFormName));
    } else {
        yield putAll(showBeError(response, title));
        yield* put(formHelpers.stopSubmit(managementOtherSubjectFormName, extractFormErrorsFromResponse(response)));
    }
}
/** Runs the admin saga that updates the selected other-subject management binding. */
export function* updateManagementOtherSubjectDetailSaga(): SagaIterator {
    yield takeLatestF('admin/UPDATE_MANAGEMENT_OTHER_SUBJECT_DETAIL', execute);
}
